import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { ReactComponent as Rightcon } from '@svgs/check.svg';
import { ReactComponent as WrongIcon } from '@svgs/close.svg';
import { bool, func, shape, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

const RightWrongButtons = ({
  areButtonsBlocked,
  customButtonTitles,
  isPassed,
  rightHandler,
  withRetry,
  wrongHandler,
}) => {
  const { isMobile } = useScreenSize();
  const { i18n } = useTranslation();

  return (
    <Flex
      flexDirection={isMobile ? 'column' : 'row'}
      gap={24}
      px={isMobile ? 0 : 40}
      py={isMobile ? 16 : 40}
      width="100%"
    >
      {!withRetry ? (
        <>
          <Button
            alignItems="center"
            {...(!isMobile && { flex: 1 })}
            buttonColor={theme.colors.red}
            disabled={areButtonsBlocked}
            onClick={wrongHandler}
            variant="colored"
          >
            <Typography
              color={theme.colors.white[100]}
              mr={12}
              variant="MS-bold-s16-lh17"
            >
              {customButtonTitles?.leftButton ||
                i18n.t('TestPage.Wrong').toUpperCase()}
            </Typography>
            <Icon
              color={theme.colors.white[100]}
              height={28}
              SVG={WrongIcon}
              width={28}
            />
          </Button>
          <Button
            alignItems="center"
            {...(!isMobile && { flex: 1 })}
            buttonColor={theme.colors.brightGreen}
            disabled={areButtonsBlocked}
            onClick={rightHandler}
            variant="colored"
          >
            <Typography
              color={theme.colors.white[100]}
              mr={12}
              variant="MS-bold-s16-lh17"
            >
              {customButtonTitles?.rightButton ||
                i18n.t('TestPage.Right').toUpperCase()}
            </Typography>
            <Icon
              color={theme.colors.white[100]}
              height={32}
              SVG={Rightcon}
              width={32}
            />
          </Button>
        </>
      ) : (
        <>
          <Button
            {...(!isMobile && { flex: 1 })}
            disabled={areButtonsBlocked}
            onClick={wrongHandler}
            variant="secondary"
          >
            <Typography
              color={theme.colors.white[100]}
              mr={12}
              variant="MS-bold-s16-lh17"
            >
              {i18n.t('TestPage.TryAgain').toUpperCase()}
            </Typography>
          </Button>
          <Button
            {...(!isMobile && { flex: 1 })}
            disabled={areButtonsBlocked}
            onClick={rightHandler}
            variant="primary"
          >
            <Typography
              color={theme.colors.background}
              variant="MS-bold-s16-lh17"
            >
              {i18n.t(`TestPage.${isPassed ? 'Finish' : 'Back'}`).toUpperCase()}
            </Typography>
          </Button>
        </>
      )}
    </Flex>
  );
};

RightWrongButtons.propTypes = {
  areButtonsBlocked: bool,
  customButtonTitles: shape({ leftButton: string, rightButton: string }),
  isPassed: bool.isRequired,
  rightHandler: func.isRequired,
  withRetry: bool.isRequired,
  wrongHandler: func.isRequired,
};

RightWrongButtons.defaultProps = {
  areButtonsBlocked: false,
  customButtonTitles: null,
};

export default RightWrongButtons;
